import report from "../report"
import dayRechargeList from "../items/day_recharge_list"
import dayClassRevenueList from "../items/day_class_revenue_list"
import studentCountList from "../items/student_count"
import rechargeDashboard from "../items/recharge_dashboard"
import eduDashboard from "../items/edu_dashbord.vue"
import flowDashboard from "../items/flow_dashboard.vue"
import classAttendanceRate from "../items/class_attendance_rate"

export default {
	path:'report',
	name:'report',
	component:report,
	children:[
		{
			path:'day/recharge/list',
			name:'day-recharge-list',
			component:dayRechargeList
		},
		{
			path:'day/class/revenue/list',
			name:'day-class-revenue-list',
			component:dayClassRevenueList
		},
		{
			path:'student/count/list',
			name:'student-count-list',
			component:studentCountList
		},
		{
			path:'recharge/dashboard',
			name:'recharge-dashboard',
			component:rechargeDashboard
		},
		{
			path:'edu/dashboard',
			name:'edu-dashboard',
			component:eduDashboard
		},
		{
			path:'flow/dashboard',
			name:'flow-dashboard',
			component:flowDashboard
		},
		{
			path:'class/attendance/rate',
			name:'class_attendance_rate',
			component:classAttendanceRate
		}
	]
}